define(['../utils', 'endpoints', 'security', 'requester/urlBuilder', 'http',
    'lodash/core', './searchTypeConfigurationFactory', './requestParamsFactory'],
function(utils, endpoints, security, urlBuilder, http, _, createSearchTypeConfiguration, createRequestParams) {
    var maxNoOfItemsForSyncBatchRequest = 100;

    function createRawBatchItemTransformer(queryParamsNames, configuration, typeParam, language) {

        function buildRequest(requestParams) {
            var request = {
                query: urlBuilder(endpoints.batchSearchQuery, requestParams.pathParams, requestParams.queryParams)
            };

            if (!_.isEmpty(requestParams.postParams)) {
                request.post = requestParams.postParams;
            }

            return request;
        }

        return function(rawBatchItem) {
            var requestParams = createRequestParams(queryParamsNames, configuration, rawBatchItem, typeParam, language);
            return buildRequest(requestParams);
        };
    }

    return function(queryParamsNames, searchTypeConfiguration) {
        var configuration = createSearchTypeConfiguration(searchTypeConfiguration);
        return function(options, callback) {
            var queryParams = {},
                bodyParams = {},
                rawBatchItems,
                endpoint,
                typeParam,
                rawBatchItemTransformer;

            queryParams.key = utils.or(options.key, security.getKey('services/search'));

            rawBatchItems = utils.required(options.batchItems);
            typeParam = configuration.type ? configuration.type : options.type;

            rawBatchItemTransformer = createRawBatchItemTransformer(queryParamsNames, configuration, typeParam,
                options.language);
            bodyParams.batchItems = rawBatchItems.map(rawBatchItemTransformer);

            endpoint = bodyParams.batchItems.length <= maxNoOfItemsForSyncBatchRequest ? endpoints.batchSyncSearch :
                endpoints.batchSearch;

            http.post({
                url: '{protocol}://' + endpoint,
                queryParameters: queryParams,
                bodyParameters: bodyParams,
                callbackParam: 'callback',
                callback: callback,
                fail: options.fail
            });
        };
    };
});



// WEBPACK FOOTER //
// ./rest/search/batchSearch.js